import request from './../request.js'

/** -----------屏幕管理页面 ----------------*/
// 列表渲染以及查询 /dev-api/iot/screen/pageList
export function screenPageList(query) {
  return request({
    url: '/iot/screen/pageList.do?',
    method: 'get',
    params: query
  })
}

// 新增/dev-api/iot/screen/add
export function screenAdd(data) {
    return request({
      url: '/iot/screen/add.do?',
      method: 'post',
      data: data
    })
  }
// 修改/dev-api/iot/screen/save
export function screenSave(data) {
  return request({
    url: '/iot/screen/save.do?',
    method: 'post',
    data: data
  })
}

// 启动和停止/dev-api/iot/screen/enable
export function qrcodeEnable(data) {
  return request({
    url: '/iot/screen/enable.do?',
    method: 'post',
    data: data
  })
}
// 删除/iot/screen/remove
export function screenRemove(data) {
  return request ({
      url:'iot/screen/remove.do?',
      method:'post',
      data:data,
      timeout:20000,
      headers:{'Content-Type': 'multipart/form-data'}
  })
}

/** -----------关联页面 ----------------*/
// 列表渲染以及查询/dev-api/iot/screen/detail/pageList
export function detailPageList(query) {
  return request({
    url: '/iot/screen/detail/pageList.do?',
    method: 'get',
    params: query
  })
}

// // 批量导入下载文件模板/dev-api/iot/screen/detail/importTemplate
export function importTemplate(data){
  return request({
    url: '/iot/screen/detail/importTemplate.do?',
    method: 'post',
    data: data,
    responseType: 'blob'
  })
}

// 批量新增 /dev-api/iot/screen/detail/import
export function detailImport(params) {
  return request ({
      url:'iot/screen/detail/import.do?',
      method:'post',
      data:params,
      timeout:20000,
  headers:{'Content-Type': 'multipart/form-data'}
  })
}

// 单个删除/dev-api/iot/screen/detail/deleteOne
export function deleteDeleteOne(params) {
  return request({
    url: '/iot/screen/detail/deleteOne.do?',
    method: 'post',
    params
  })
}
// 批量删除/dev-api/iot/screen/detail/delete
export function deleteDelete(query) {
  return request({
    url: '/iot/screen/detail/delete.do?',
    method: 'post',
    params:query
  })
}

// 单个新增 /dev-api/iot/screen/detail/add
export function detailAdd(params) {
  return request({
    url: '/iot/screen/detail/add.do?',
    method:'post',
      data:params,
      timeout:20000,
  headers:{'Content-Type': 'multipart/form-data'}
  })
}